module.exports = __webpack_public_path__ + "img/icon-spock.b6446e8e.svg";